import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Embed-friendly storefront for eventism.com (or any partner site).
 * Renders public inventory + a "Book on Party Rentals Express" CTA.
 * No nav, no footer, transparent body — designed for <iframe>.
 */
export default function Embed() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/inventory").then(({ data }) => setItems(data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-white p-6" data-testid="embed-root">
      <div className="max-w-5xl mx-auto">
        <div className="flex items-center justify-between mb-4">
          <div>
            <p className="text-[9px] font-black uppercase tracking-[0.4em] text-brand-red">
              An Eventism Service
            </p>
            <h2 className="text-2xl font-black uppercase tracking-tightest text-brand-blue">
              Park Hill Pod • Live Inventory
            </h2>
          </div>
          <a
            href={window.location.origin}
            target="_top"
            rel="noopener noreferrer"
            className="btn-primary px-5 py-2 rounded-lg font-black uppercase text-[10px] tracking-widest"
            data-testid="embed-open-storefront"
          >
            Open Storefront <i className="fas fa-arrow-right ml-1" />
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
          {items.map((it) => (
            <div
              key={it.id}
              className="bg-slate-50 rounded-2xl p-3 border border-slate-100 border-b-4 border-b-brand-gold"
              data-testid={`embed-item-${it.id}`}
            >
              <div className="w-full aspect-square rounded-xl overflow-hidden bg-white flex items-center justify-center text-brand-blue mb-2">
                {it.image_url ? (
                  <img src={it.image_url} alt={it.name} className="w-full h-full object-cover" />
                ) : (
                  <i className={`fas ${it.icon} text-3xl`} />
                )}
              </div>
              <p className="font-black text-[10px] uppercase tracking-tightest text-brand-blue truncate">
                {it.name}
              </p>
              <p className="text-sm font-black text-brand-red">
                ${it.price_per_day.toFixed(2)}
                <span className="text-[8px] text-slate-400 font-bold ml-1">/day</span>
              </p>
            </div>
          ))}
        </div>

        <p className="mt-4 text-center text-[9px] font-black uppercase tracking-[0.3em] text-slate-400">
          Powered by Party Rentals Express • 3475 Holly St, Denver
        </p>
      </div>
    </div>
  );
}
